import { render, staticRenderFns } from "./PainelProjetosUnidade.vue?vue&type=template&id=26ff8252"
import script from "./PainelProjetosUnidade.vue?vue&type=script&lang=js"
export * from "./PainelProjetosUnidade.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosUnidade.vue?vue&type=style&index=0&id=26ff8252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports